import { api } from './api';

export default async function fetchExchangeRateData({
	accessToken,
	year,
	countryId,
}) {
	const res = await api.get('/GetForecastQuota', {
		params: {
			countryId,
			year,
		},
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	});

	if (!res?.data) return [];

	return [
		{
			id: 1,
			...res?.data?.data?.[0]?.exchangeRate,
		},
	];
}
